<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>输入资产编码</span>
    </div>
    <div class="code-wrapper">
      <img src="../../../assets/images/login-logo.png">
      <div class="code-search">
        <input type="text" v-model="input_goods_num" placeholder="请准确输入物品上的数字编码" />
        <div @click="checkCode()">盘点</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'StocktakingEnterCode',
  metaInfo: {
    title: '输入耗材编码'
  },
  data () {
    return {
      stocktaking_id: 0,
      input_goods_num: '' // 盘点物品编码（扫码或录码结果）
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.stocktaking_id = this.$route.query.stocktaking_id
  },
  methods: {
    // 物品编码校验
    checkCode () {
      if (this.input_goods_num === '') {
        this.$toast({
          message: '未获取到物品编码',
          duration: 2000
        })
        return false
      }
      // 判断是否在物品档案中
      this.axios.post('/wechat/goods/goodsDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        goods_num: this.input_goods_num
      }).then((res) => {
        if (res.data.status === 1) {
          var goodsInfo = res.data.data
          if (goodsInfo.goods_type !== 1) {
            this.$messagebox({
              message: '未找到编号' + this.input_goods_num + '耗材',
              closeOnClickModal: false,
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return false
          }
          // 判断耗材是否在盘点单内
          this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
            member_id: this.memberId,
            village_id: this.villageId,
            stocktaking_id: this.stocktaking_id,
            goods_id: goodsInfo.goods_id
          }).then((res2) => {
            if (res2.data.status === 1) {
              if (res2.data.data.stocktaking_info.goods.length > 0) {
                // 在盘点单内
                var detail = res2.data.data.stocktaking_info.goods[0]
                this.$router.push({name: 'StocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
              } else {
                // 不在盘点单内
                this.$messagebox({
                  message: '该耗材不在本次盘点范围，是否继续盘点',
                  closeOnClickModal: false,
                  showCancelButton: true,
                  confirmButtonText: '盘点'
                }).then(action => {
                  if (action === 'confirm') { // 确认的回调
                    var detail = {}
                    detail.goods_id = goodsInfo.goods_id
                    detail.goods_num = goodsInfo.goods_num
                    detail.goods_name = goodsInfo.goods_name
                    detail.due_count = 0
                    this.$router.push({name: 'StocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
                  }
                })
              }
            }
          }).catch(() => {
            this.$toast({
              message: '网络错误',
              duration: 5000
            })
          })
        } else {
          this.$messagebox({
            message: '未找到编号' + this.input_goods_num + '耗材',
            closeOnClickModal: false,
            showCancelButton: false,
            confirmButtonText: '确定'
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #ffffff;
}
.code-wrapper {
  text-align: center;
  padding: 25px;
}
.code-wrapper .code-search {
  margin-top: 20px;
  display: flex;
}
.code-wrapper .code-search input {
  flex: 1;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  padding: 0 10px;
}
.code-wrapper .code-search div {
  width: 50px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #313131;
  margin-left: 10px;
  border-radius: 6px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Stocktaking/StocktakingEnterCode.vue